<template>
  <v-app>
    <head><link href="https://fonts.googleapis.com/css?family=Kosugi+Maru&display=swap" rel="stylesheet"></head>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
              <v-img src="../assets/top-jumbo3.jpg" 
                  color="primary"
                  width="100%"
                  height="500">
                  <v-container>
                    <v-layout justify-center fill-height column align-center>
                        <v-card-title><span class="display-3"><span class="red--text">Ruby</span><v-icon large color="red">code</v-icon><br>技術者認定試験<br><span class="red--text">一問一答</span></span><br></v-card-title>
                        <p class="headline">Let's study <span class="red--text">Ruby!</span></p>
                    </v-layout>
                    <v-layout>
                      <v-container>
                        <v-layout justify-center　row wrap>
                          <span class="title bold" v-if="!current_user">使用するアカウントを選んでください</span>
                          <v-btn   color="primary" v-if="!current_user" @click="signInGoogle"><v-icon>mdi-google</v-icon>google</v-btn>
                          <v-btn   color="success" v-if="!current_user" @click="signInGitHub" class="ml-1"><v-icon>mdi-github-box</v-icon>github</v-btn>
                          <div v-if="current_user">
                            <router-link to="/silver-exma1"><v-btn large color="blue-grey lighten-3" >Silver問題1へ</v-btn></router-link>
                          </div>
                          <div v-if="current_user">
                            <router-link to="/gold-exam1"><v-btn large color="yellow darken-1" class="ml-2" >Gold問題1へ</v-btn></router-link>
                          </div>
                        </v-layout>
                      </v-container>                  
                    </v-layout>
                  </v-container>
              </v-img>
            <v-card-text>
              <span class="title">
                  <p>このサイトで、<a href="https://www.ruby.or.jp/ja/certification/examination/" target="_blank">Ruby技術者認定試験<v-icon color="info">open_in_new</v-icon></a>の学習をしましょう！</p>
              </span>
            </v-card-text>
            <v-card-text v-if="!current_user">
              <v-layout column >
                <div>
                  <p><v-icon>announcement</v-icon>ここではRuby技術者認定試験の模擬問題を一問一答形式で解くことができます。サービスの利用にはGoogleまたはGitHubのアカウントが必要です。</p>
                  <p>アカウントをお持ちでない方は、<a class="blue--text" @click="signUp">登録</a>をお願いします。</p>
                </div>
              </v-layout>
            </v-card-text>
          </v-card>
          
          <v-layout>
            <v-flex xs12>
              <v-card>
                <v-alert color="success"><v-icon color="white">announcement</v-icon><span class="white--text">What's this site?</span></v-alert>
                <v-container>
                  <v-icon>stay_primary_portrait</v-icon><span class="title">スマホでも気軽に試験勉強</span>
                  <v-card-text>Ruby技術者認定試験対策用の問題を一問一答形式で学習しましょう</v-card-text>
                  <v-icon>import_contacts</v-icon><span class="title">Rubyの基礎を学習</span>
                  <v-card-text>Rubyを扱う上で知っておくと、便利な基礎を学習できます</v-card-text>
                  <v-icon>input</v-icon><span class="title">知識のインプット</span>
                  <v-card-text>間違った問題は、<a href="https://docs.ruby-lang.org/ja/" target="_blank">リファレンスマニュアル<v-icon color="info">open_in_new</v-icon></a>で確認しましょう！</v-card-text>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-card>
                <v-alert color="info"><v-icon color="white">info</v-icon><span class="white--text">更新履歴</span></v-alert>
                <v-container>
                  <v-list >
                    <v-list-item>
                      <v-list-item-icon><v-icon>fiber_new</v-icon></v-list-item-icon>
                      <v-list-item-content><span>2019-08-11 Ruby Silverの問題を追加（<a href="https://gist.github.com/sean2121/945035ef2341f0c39bf40762cd8531e0" target="_blank">掲載元<v-icon>open_in_new</v-icon></a>の許可済み）</span></v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-card>
                <v-alert color="error"><v-icon color="white">warning</v-icon><span class="white--text">利用上の注意:本問題の利用による損害が発生しても、管理者はその責任を負いません</span></v-alert>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
  </v-app>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'HelloWorld',
  data: () => ({
      current_user:""
  }),
  methods:{
    signInGoogle:function(){
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider).then(result => {
            alert('認証に成功しました');
            this.$router.push('/');
        }).catch(error => {
            this.errorMessage = error.message
            this.showError = true
        })
    },
    signInGitHub:function(){
        const provider = new firebase.auth.GithubAuthProvider();
        firebase.auth().signInWithPopup(provider).then(result => {
            alert('GitHub認証に成功しました');
            this.$router.push('/');
        }).catch(error => {
            this.errorMessage = error.message
            this.showError = true
        })
    },
    signUp:function(){
        var provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider)
            .then(obj => {
            alert('Create account: ' + obj.user.displayName)
            })
            .catch(error => alert(error.message))
    }
  },
  created(){
        var self = this
        firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            self.current_user = user
        } 
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body{
  font-family: 'Kosugi Maru', sans-serif;
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-application--wrap{
    min-height: 0;
}
</style>
